// @ts-nocheck
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {toast} from "@/components";
import {depositPagoMovilService} from "../../services/wallet/deposit.service";

const useDepositPagoMovil = () => {
  const {t} = useTranslation();
  const queryClient = useQueryClient();
  const {isError, isPending, isSuccess, refetch, error, mutate, status} = useMutation({
    mutationKey: ["postDepositTopUp"],
    mutationFn: depositPagoMovilService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userWalletDeposit"]});
      toast.success({
        title: t("depositInstructionsBankTitle"),
        description: t("depositInstructionsBankSuccess"),
      });
    },
    onError: _error => {
      queryClient.invalidateQueries({queryKey: ["userWalletDeposit"]});
      toast.warning({
        title: t("depositInstructionsBankWarning"),
        description: t("depositInstructionsBanckError"),
      });
    },
  });

  return {isError, isPending, refetch, isSuccess, error, mutate, status};
};

export default useDepositPagoMovil;
